import alert from "./alert";
import loading from "./loading";
import scp from "./scp"
import log from "./log"

export const execEffect = async (dispatch, action, onError) => {
      try {
            dispatch.loading.start();
            return await action();
      } catch (e) {
            log.error(e);
            if (onError) onError(e);
      } finally {
            dispatch.loading.stop();
      }
};

export default { loading, alert, scp };
